<style>
  /* Lock scrolling completely for login page */
  html, body {
    height: 100vh !important;
    width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
  }
  
  /* Prevent any child elements from causing scroll */
  body * {
    max-width: 100vw !important;
  }
</style>

<div class="fixed inset-0 overflow-hidden flex items-center justify-center px-4 bg-gradient-to-br from-slate-50 via-primary-50 to-secondary-50">
  <!-- decorative blobs -->
  <div class="absolute -left-24 -top-24 w-72 h-72 rounded-full bg-gradient-to-br from-primary-300 to-secondary-300 opacity-30 blur-3xl transform -rotate-12"></div>
  <div class="absolute -right-24 -bottom-24 w-56 h-56 rounded-full bg-gradient-to-br from-secondary-200 to-primary-200 opacity-25 blur-2xl"></div>

  <div class="w-full max-w-md">
    <div class="bg-white/80 backdrop-blur-md border border-slate-200/60 rounded-3xl shadow-2xl p-8 animate-fade-in">
      <div class="flex items-center gap-4 mb-6">
        <div class="w-14 h-14 rounded-full bg-white shadow-lg flex items-center justify-center p-2">
          <img src="assets/logo.svg" alt="Mental Health Chatbot Logo" class="w-full h-full object-contain">
        </div>
        <div>
          <h2 class="text-2xl font-semibold text-slate-800">Admin Login</h2>
          <p class="text-sm text-slate-500">Mental Health Chatbot Dashboard</p>
        </div>
      </div>

      <div *ngIf="error" class="mb-4 text-sm text-red-600 bg-red-50 p-3 rounded">{{ error }}</div>

      <form (ngSubmit)="login()" class="space-y-4">
        <label class="block text-sm text-slate-600">Username</label>
        <input [(ngModel)]="username" name="username" required
          placeholder="admin@example.com"
          class="w-full px-4 py-3 rounded-xl border border-slate-200 bg-white focus:outline-none focus:ring-2 focus:ring-primary-300 transition placeholder-slate-400" />

        <label class="block text-sm text-slate-600">Password</label>
        <input [(ngModel)]="password" name="password" type="password" required
          placeholder="••••••••"
          class="w-full px-4 py-3 rounded-xl border border-slate-200 bg-white focus:outline-none focus:ring-2 focus:ring-primary-300 transition placeholder-slate-400" />

        <div class="flex items-center justify-between mt-2">
          <div class="text-sm text-slate-500"><a class="text-primary-600 hover:underline" href="#">Forgot?</a></div>
          <button type="submit" class="inline-flex items-center gap-2 bg-gradient-to-r from-primary-600 to-secondary-600 text-white px-5 py-2 rounded-xl shadow-lg hover:scale-[1.02] transform transition duration-200">Login</button>
        </div>
      </form>

      <div class="mt-6 text-center text-xs text-slate-400">Forgot password? Contact the system administrator.</div>
    </div>
    <div class="mt-4 text-center">
      <a routerLink="/" class="inline-block text-sm text-primary-600 hover:underline">← Back to Chat</a>
    </div>
    <p class="mt-4 text-center text-xs text-slate-400">© {{ currentYear }} JoyBot Mental Health Support</p>
  </div>
</div>
